import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 21 21'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path fill='currentColor' d='M10.25 13.045 5.538 8.333l.878-.878 3.833 3.833 3.834-3.833.878.878z' />
  </svg>
)
export default SvgComponent
